import { useQuery } from '@tanstack/react-query'
import { lobbyQueryOptions, useAdmitGuestMutation } from '@/entities/meeting'

// Очередь ожидающих гостей — poll, активный пока панель смонтирована.
// enabled=false для не-организатора: бэк отдаёт lobby только организатору.
export function useLobby(meetingId: string, enabled = true) {
  return useQuery({ ...lobbyQueryOptions(meetingId), enabled })
}

export function useAdmitGuest(meetingId: string) {
  return useAdmitGuestMutation(meetingId)
}
